import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	label: {
		id: 'issue-field-issue-type-editview-full.issue-type.label',
		defaultMessage: 'Select work type. {issueType} currently selected.',
		description: 'Aria label for accessibility',
	},
});
